import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_media_field = _resolveComponent("media-field")

  return (_openBlock(), _createBlock(_component_media_field, {
    name: "avatarImageUrl",
    "media-class": "gfu-avatar gfu-avatar-image",
    "media-field-class": "_jc-c",
    "upload-api-function": $options.uploadApiFunction,
    "thumb-url": $data.model.avatarImagePreview,
    class: "_w-100 _tac",
    onMediaUploaded: $options.onImageChanged,
    onError: $options.handleError,
    "data-qa": "account-settings:AvatarImage"
  }, null, 8 /* PROPS */, ["upload-api-function", "thumb-url", "onMediaUploaded", "onError"]))
}